import { useNavigate } from "react-router-dom";
import { getTextWorkCity, getTextWorkTime, getLimitedDetailText, getTextVisaStat, convertTitleText } from "../component/common/BaseUtil"
import { useState, useEffect } from 'react';
import '../App.css';

export function PersonCard(props) {
    const [validPerson, setValidPerson] = useState(false);

    useEffect(() => {
        
    }, []);
    
    let navigate = useNavigate();
    function onClick() {
        let objectId = props.object.id.toString()
        let returnTo = props.returnTo
        let url = "/person?id=" + objectId + "&returnTo=" + returnTo;
        navigate(url);
    }
    //타이틀
    //근무도시, 근무형태
    //비자상태
    //모집상세
    //나이, 성별?
    return (
        <div class="card" key={props.index} style={{ marginTop: '15px', marginBottom: '15px' }}>
            <div class="card-body">
                <h4 class="card-title" className="responsive-card-title" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', whiteSpace: "break-spaces"}}>{convertTitleText(props.object.objTitle)}</h4>
                <p class="card-text" className="responsive-card-content" style={{whiteSpace: "break-spaces"}}>{getLimitedDetailText(props.object.pvIntro)}</p>
                <p class="card-text" style={{ fontFamily: 'Nanum Gothic' }}>근무도시: {getTextWorkCity(props.cityList, props.object.workCity)} | 근무형태: {getTextWorkTime(props.object.workTime)}</p>
                {/* <h6 class="text-muted card- mb-2" style={{ fontFamily: 'Nanum Gothic' }}>비자상태: {getTextVisaStat(props.object.visaStat)}</h6> */}
                <button class="btn btn-outline-info" onClick={onClick} type="button">자세히</button>
            </div>
        </div> 
    );
}